if (!window.residualsSizeDrawerReady) {
      window.residualsSizeDrawerReady = true;
      const chosenSizes = new Map();
      const syncChosenSizes = () => {
        document.querySelectorAll('.residuals-size-select__open').forEach((button) => {
          const productId = button.closest('variant-picker')?.dataset.productId;
          const selected = chosenSizes.get(productId);
          if (selected && button.textContent !== 'SIZE ' + selected) button.textContent = 'SIZE ' + selected;
          const picker = button.closest('variant-picker');
          const guide = picker?.querySelector('.residuals-size-select__guide');
          const visible = picker?.querySelector('.residuals-size-guide')?.hidden === false;
          if (guide && guide.hidden === visible) guide.hidden = !visible;
        });
      };
      let syncScheduled = false;
      const observer = new MutationObserver(() => {
        if (syncScheduled) return;
        syncScheduled = true;
        requestAnimationFrame(() => { syncScheduled = false; syncChosenSizes(); });
      });
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const open = event.target.closest('.residuals-size-select__open');
        if (open) {
          const dialog = document.getElementById(open.getAttribute('aria-controls'));
          if (dialog && !dialog.open) {
            const picker = open.closest('variant-picker');
            const guide = dialog.querySelector('.residuals-size-select__guide');
            if (guide) guide.hidden = picker.querySelector('.residuals-size-guide')?.hidden !== false;
            dialog.showModal();
          }
          return;
        }
        const sizeRow = event.target.closest('.residuals-size-select__dialog .variant-option__button-label');
        if (sizeRow) {
          const input = sizeRow.querySelector('input[type="radio"]');
          if (input?.checked) {
            const dialog = sizeRow.closest('dialog');
            const opener = document.querySelector('[aria-controls="' + dialog.id + '"]');
            const productId = opener?.closest('variant-picker')?.dataset.productId;
            if (productId) chosenSizes.set(productId, input.value);
            if (opener) opener.textContent = 'SIZE ' + input.value;
            dialog.close();
            opener?.focus();
          }
          return;
        }
        const close = event.target.closest('.residuals-size-select__close');
        if (close) close.closest('dialog')?.close();
        const guide = event.target.closest('.residuals-size-select__guide');
        if (guide) {
          const dialog = guide.closest('dialog');
          const picker = guide.closest('variant-picker');
          dialog?.close();
          requestAnimationFrame(() => picker?.querySelector('.residuals-size-guide__trigger')?.click());
        }
      });
      document.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;
        const dialog = event.target.closest('.residuals-size-select__dialog');
        if (!dialog) return;
        const open = document.querySelector('[aria-controls="' + dialog.id + '"]');
        if (open) {
          const productId = open.closest('variant-picker')?.dataset.productId;
          if (productId) chosenSizes.set(productId, event.target.value);
          open.textContent = 'SIZE ' + event.target.value;
          dialog.close();
          open.focus();
        }
      });
    }
